import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect } from 'react';
import { triggerCommentReplyInContextAborted, triggerCommentReplyInContextFailed, triggerCommentReplyInContextSucceeded, triggerFetchConfluenceCommentDataInContextAborted, triggerFetchConfluenceCommentDataInContextFailed, triggerFetchConfluenceCommentDataInContextSucceeded, triggerNotificationsRenderAborted, triggerNotificationsRenderFailed, triggerNotificationsRenderSucceeded, triggerReactionAddedInContextAborted, triggerReactionAddedInContextFailed, triggerReactionAddedInContextSucceeded, triggerReactionDeletedInContextAborted, triggerReactionDeletedInContextFailed, triggerReactionDeletedInContextSucceeded, triggerReactionSummaryInContextAborted, triggerReactionSummaryInContextFailed, triggerReactionSummaryInContextSucceeded, useCreateFireAnalyticsFromTrigger } from '../analytics';
import { SloFailureReason } from '../analytics/types';
import { useExperienceTracker } from './adapter/context';
import { AbortReason, ExperienceIds, Experiences } from './types';
import { getExperienceTimeout, getNotificationMountStartMark } from './utils';
export var useNotificationsExperienceTracking = function useNotificationsExperienceTracking() {
  var experienceTracker = useExperienceTracker();
  var fireNotificationsRenderSucceeded = useCreateFireAnalyticsFromTrigger(triggerNotificationsRenderSucceeded);
  var fireNotificationsRenderFailed = useCreateFireAnalyticsFromTrigger(triggerNotificationsRenderFailed);
  var fireNotificationsRenderAborted = useCreateFireAnalyticsFromTrigger(triggerNotificationsRenderAborted);
  var fireReactionAddedInContextSucceeded = useCreateFireAnalyticsFromTrigger(triggerReactionAddedInContextSucceeded);
  var fireReactionAddedInContextFailed = useCreateFireAnalyticsFromTrigger(triggerReactionAddedInContextFailed);
  var fireReactionAddedInContextAbort = useCreateFireAnalyticsFromTrigger(triggerReactionAddedInContextAborted);
  var fireReactionDeletedInContextSucceeded = useCreateFireAnalyticsFromTrigger(triggerReactionDeletedInContextSucceeded);
  var fireReactionDeletedInContextFailed = useCreateFireAnalyticsFromTrigger(triggerReactionDeletedInContextFailed);
  var fireReactionDeletedInContextAbort = useCreateFireAnalyticsFromTrigger(triggerReactionDeletedInContextAborted);
  var fireReactionSummaryFetchedSucceeded = useCreateFireAnalyticsFromTrigger(triggerReactionSummaryInContextSucceeded);
  var fireReactionSummaryFetchedFailed = useCreateFireAnalyticsFromTrigger(triggerReactionSummaryInContextFailed);
  var fireReactionSummaryFetchedAborted = useCreateFireAnalyticsFromTrigger(triggerReactionSummaryInContextAborted);
  var fireCommentReplyInContextSucceeded = useCreateFireAnalyticsFromTrigger(triggerCommentReplyInContextSucceeded);
  var fireCommentReplyInContextFailed = useCreateFireAnalyticsFromTrigger(triggerCommentReplyInContextFailed);
  var fireCommentReplyInContextAborted = useCreateFireAnalyticsFromTrigger(triggerCommentReplyInContextAborted);
  var fireCommentDataInContextSucceeded = useCreateFireAnalyticsFromTrigger(triggerFetchConfluenceCommentDataInContextSucceeded);
  var fireCommentDataInContextFailed = useCreateFireAnalyticsFromTrigger(triggerFetchConfluenceCommentDataInContextFailed);
  var fireCommentDataInContextAborted = useCreateFireAnalyticsFromTrigger(triggerFetchConfluenceCommentDataInContextAborted);
  useEffect(function () {
    return function () {
      experienceTracker.abort({
        name: Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT,
        reason: AbortReason.COMPONENT_UNMOUNTED
      });
      experienceTracker.abort({
        name: Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT,
        reason: AbortReason.COMPONENT_UNMOUNTED
      });
      experienceTracker.abort({
        name: Experiences.RENDER_NOTIFICATION_PAGE_WITH_CONTENT,
        reason: AbortReason.COMPONENT_UNMOUNTED
      });
      experienceTracker.abort({
        name: Experiences.ADD_REACTION_IN_CONTEXT,
        reason: AbortReason.COMPONENT_UNMOUNTED
      }), experienceTracker.abort({
        name: Experiences.DELETE_REACTION_IN_CONTEXT,
        reason: AbortReason.COMPONENT_UNMOUNTED
      }), experienceTracker.abort({
        name: Experiences.FETCH_REACTION_SUMMARY_IN_CONTEXT,
        reason: AbortReason.COMPONENT_UNMOUNTED
      }), experienceTracker.abort({
        name: Experiences.FETCH_COMMENT_DATA_IN_CONTEXT,
        reason: AbortReason.COMPONENT_UNMOUNTED
      }), experienceTracker.abort({
        name: Experiences.COMMENT_REPLY_IN_CONTEXT,
        reason: AbortReason.COMPONENT_UNMOUNTED
      });
    };
  }, [experienceTracker]);
  useEffect(function () {
    return setupExperienceTracking(experienceTracker, fireNotificationsRenderSucceeded, fireNotificationsRenderFailed, fireNotificationsRenderAborted, fireReactionAddedInContextSucceeded, fireReactionAddedInContextFailed, fireReactionAddedInContextAbort, fireReactionDeletedInContextSucceeded, fireReactionDeletedInContextFailed, fireReactionDeletedInContextAbort, fireReactionSummaryFetchedSucceeded, fireReactionSummaryFetchedFailed, fireReactionSummaryFetchedAborted, fireCommentReplyInContextSucceeded, fireCommentReplyInContextFailed, fireCommentReplyInContextAborted, fireCommentDataInContextSucceeded, fireCommentDataInContextFailed, fireCommentDataInContextAborted);
  }, [experienceTracker, fireNotificationsRenderSucceeded, fireNotificationsRenderFailed, fireNotificationsRenderAborted, fireReactionAddedInContextSucceeded, fireReactionAddedInContextFailed, fireReactionAddedInContextAbort, fireReactionDeletedInContextSucceeded, fireReactionDeletedInContextFailed, fireReactionDeletedInContextAbort, fireReactionSummaryFetchedSucceeded, fireReactionSummaryFetchedFailed, fireReactionSummaryFetchedAborted, fireCommentReplyInContextSucceeded, fireCommentReplyInContextFailed, fireCommentReplyInContextAborted, fireCommentDataInContextSucceeded, fireCommentDataInContextFailed, fireCommentDataInContextAborted]);
};
var setupExperienceTracking = function setupExperienceTracking(experienceTracker, fireNotificationsRenderSucceeded, fireNotificationsRenderFailed, fireNotificationsRenderAborted, fireReactionAddedInContextSucceeded, fireReactionAddedInContextFailed, fireReactionAddedInContextAbort, fireReactionDeletedInContextSucceeded, fireReactionDeletedInContextFailed, fireReactionDeletedInContextAbort, fireReactionSummaryFetchedSucceeded, fireReactionSummaryFetchedFailed, fireReactionSummaryFetchedAborted, fireCommentReplyInContextSucceeded, fireCommentReplyInContextFailed, fireCommentReplyInContextAborted, fireCommentDataInContextSucceeded, fireCommentDataInContextFailed, fireCommentDataInContextAborted) {
  return experienceTracker.subscribe(function (event) {
    if (event.name === Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT || event.name === Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT) {
      var _withContent = event.name === Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT;
      var _firstLoad = event.id === ExperienceIds.FIRST_LOAD;
      var _duration;
      var _getNotificationMount = getNotificationMountStartMark(),
        _getNotificationMount2 = _slicedToArray(_getNotificationMount, 2),
        performance = _getNotificationMount2[0],
        customStartTime = _getNotificationMount2[1];
      if (customStartTime !== undefined) {
        var nowMark = performance.now();
        _duration = nowMark - customStartTime;
      }
      var totalDuration = _duration || event.duration;
      if (event.action === 'taskSuccess') {
        var successAttributes = event.attributes;
        fireNotificationsRenderSucceeded(_firstLoad, _withContent, totalDuration, (successAttributes === null || successAttributes === void 0 ? void 0 : successAttributes.noNotificationsScreen) || false);
      } else if (event.action === 'taskFail') {
        fireNotificationsRenderFailed(_firstLoad, _withContent, totalDuration, event.error.message, event.attributes || {});
      } else if (event.action === 'taskAbort') {
        if (event.reason === AbortReason.COMPONENT_UNMOUNTED) {
          var timeout = getExperienceTimeout(event.name);
          if (totalDuration > timeout) {
            fireNotificationsRenderFailed(_firstLoad, _withContent, totalDuration, SloFailureReason.ABORT_TIMEOUT, event.attributes || {});
            return;
          }
        }
        fireNotificationsRenderAborted(_firstLoad, _withContent, totalDuration, event.reason, event.attributes || {});
      }
    } else if (event.name === Experiences.ADD_REACTION_IN_CONTEXT) {
      var _duration2;
      var _getNotificationMount3 = getNotificationMountStartMark(),
        _getNotificationMount4 = _slicedToArray(_getNotificationMount3, 2),
        _performance = _getNotificationMount4[0],
        _customStartTime = _getNotificationMount4[1];
      if (_customStartTime !== undefined) {
        var _nowMark = _performance.now();
        _duration2 = _nowMark - _customStartTime;
      }
      var _totalDuration = _duration2 || event.duration;
      if (event.action === 'taskSuccess') {
        fireReactionAddedInContextSucceeded(event.name, event.attributes.emojiId, _totalDuration);
      } else if (event.action === 'taskFail') {
        fireReactionAddedInContextFailed(event.name, event.attributes.emojiId, _totalDuration, event.error.message);
      } else if (event.action === 'taskAbort') {
        fireReactionAddedInContextAbort(event.name, event.attributes.emojiId, _totalDuration, event.reason);
      }
    } else if (event.name === Experiences.DELETE_REACTION_IN_CONTEXT) {
      var _duration3;
      var _getNotificationMount5 = getNotificationMountStartMark(),
        _getNotificationMount6 = _slicedToArray(_getNotificationMount5, 2),
        _performance2 = _getNotificationMount6[0],
        _customStartTime2 = _getNotificationMount6[1];
      if (_customStartTime2 !== undefined) {
        var _nowMark2 = _performance2.now();
        _duration3 = _nowMark2 - _customStartTime2;
      }
      var _totalDuration2 = _duration3 || event.duration;
      if (event.action === 'taskSuccess') {
        fireReactionDeletedInContextSucceeded(event.name, event.attributes.emojiId, _totalDuration2);
      } else if (event.action === 'taskFail') {
        fireReactionDeletedInContextFailed(event.name, event.attributes.emojiId, _totalDuration2, event.error.message);
      } else if (event.action === 'taskAbort') {
        fireReactionDeletedInContextAbort(event.name, event.attributes.emojiId, _totalDuration2, event.reason);
      }
    } else if (event.name === Experiences.FETCH_REACTION_SUMMARY_IN_CONTEXT) {
      var _duration4;
      var _getNotificationMount7 = getNotificationMountStartMark(),
        _getNotificationMount8 = _slicedToArray(_getNotificationMount7, 2),
        _performance3 = _getNotificationMount8[0],
        _customStartTime3 = _getNotificationMount8[1];
      if (_customStartTime3 !== undefined) {
        var _nowMark3 = _performance3.now();
        _duration4 = _nowMark3 - _customStartTime3;
      }
      var _totalDuration3 = _duration4 || event.duration;
      if (event.action === 'taskSuccess') {
        fireReactionSummaryFetchedSucceeded(event.name, _totalDuration3);
      } else if (event.action === 'taskFail') {
        fireReactionSummaryFetchedFailed(event.name, _totalDuration3, event.error.message);
      } else if (event.action === 'taskAbort') {
        fireReactionSummaryFetchedAborted(event.name, _totalDuration3, event.reason);
      }
    } else if (event.name === Experiences.COMMENT_REPLY_IN_CONTEXT) {
      var _duration5;
      var _getNotificationMount9 = getNotificationMountStartMark(),
        _getNotificationMount0 = _slicedToArray(_getNotificationMount9, 2),
        _performance4 = _getNotificationMount0[0],
        _customStartTime4 = _getNotificationMount0[1];
      if (_customStartTime4 !== undefined) {
        var _nowMark4 = _performance4.now();
        _duration5 = _nowMark4 - _customStartTime4;
      }
      var _totalDuration4 = _duration5 || event.duration;
      if (event.action === 'taskSuccess') {
        fireCommentReplyInContextSucceeded(event.name, event.attributes.mutationType, event.attributes.containerType, _totalDuration4);
      } else if (event.action === 'taskFail') {
        fireCommentReplyInContextFailed(event.name, event.attributes.mutationType, event.attributes.containerType, _totalDuration4, event.error.message);
      } else if (event.action === 'taskAbort') {
        fireCommentReplyInContextAborted(event.name, _totalDuration4, event.reason);
      }
    } else if (event.name === Experiences.FETCH_COMMENT_DATA_IN_CONTEXT) {
      var _duration6;
      var _getNotificationMount1 = getNotificationMountStartMark(),
        _getNotificationMount10 = _slicedToArray(_getNotificationMount1, 2),
        _performance5 = _getNotificationMount10[0],
        _customStartTime5 = _getNotificationMount10[1];
      if (_customStartTime5 !== undefined) {
        var _nowMark5 = _performance5.now();
        _duration6 = _nowMark5 - _customStartTime5;
      }
      var _totalDuration5 = _duration6 || event.duration;
      if (event.action === 'taskSuccess') {
        fireCommentDataInContextSucceeded(event.name, event.attributes.commentId, _totalDuration5);
      } else if (event.action === 'taskFail') {
        fireCommentDataInContextFailed(event.name, event.attributes.commentId, _totalDuration5, event.error.message);
      } else if (event.action === 'taskAbort') {
        fireCommentDataInContextAborted(event.name, _totalDuration5, event.reason);
      }
    }
  });
};
export var NotificationsExperienceTracker = function NotificationsExperienceTracker(_ref) {
  var children = _ref.children;
  useNotificationsExperienceTracking();
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export var generateNotificationContentRenderExperienceName = function generateNotificationContentRenderExperienceName(notification) {
  return {
    name: Experiences.RENDER_INDIVIDUAL_NOTIFICATION_WITH_CONTENT,
    nameId: notification.id
  };
};